import { Span } from 'components/common/atoms'
import { COLOR } from 'styles/constants'

import { StyledButton } from './style'

export const PrevArrow = ({
  className,
  style,
  onClick,
}: {
  className?: string
  style?: Record<string, unknown>
  onClick?: () => void
}) => (
  <StyledButton className={className} style={style} onClick={onClick}>
    <Span $color={COLOR.GREY_LV1} $size="20px">
      <i className="fas fa-chevron-left" />
    </Span>
  </StyledButton>
)
